import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizProblem, PrintQuizImage, PrintInputBox, PRINT_CORRECT_ANSWER_CLASS, getStyles } from "./print-common.js";
function CountingPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const numDigits = quiz.digits || 1;
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const correctDigits = (() => {
    if (!showCorrectAnswers || !(correctAnswers == null ? void 0 : correctAnswers[0])) return null;
    return correctAnswers[0].split("").map(Number);
  })();
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    /* @__PURE__ */ jsx(
      PrintQuizProblem,
      {
        problem: quiz.problem,
        quizId,
        additionalImages: quiz.additionalImages,
        compact,
        stripBlanks: true
      }
    ),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx("div", { className: cn("flex items-center justify-center w-full", compact ? "gap-[10px]" : "gap-[20px]"), children: Array.from({ length: numDigits }).map((_, index) => {
      const correctDigit = correctDigits == null ? void 0 : correctDigits[index];
      const showDigit = showCorrectAnswers && correctDigit != null;
      return /* @__PURE__ */ jsx(
        PrintInputBox,
        {
          size: "md",
          compact,
          className: showDigit ? `text-[20px] ${PRINT_CORRECT_ANSWER_CLASS}` : "",
          children: showDigit ? correctDigit : " "
        },
        index
      );
    }) })
  ] });
}
export {
  CountingPrint
};
//# sourceMappingURL=counting-print.js.map
